import React, { useState } from 'react';
import {
  MANAGER_MENU_ITEMS,
  getManagerMenuLabelByStoredValue,
} from '../../utils/managerUtils';

const MenuListSelector = ({ selectedMenus, setSelectedMenus, menuItems = MANAGER_MENU_ITEMS }) => {
  const [dragItem, setDragItem] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(-1);

  const usedIds = new Set(selectedMenus.map(item => item.id));

  const appendMenu = menuId => {
    const label = getManagerMenuLabelByStoredValue(menuId, menuItems);
    if (!label) return;

    setSelectedMenus(prev => {
      if (prev.some(item => item.id === menuId)) return prev;
      return [...prev, { id: menuId, label }];
    });
  };

  const moveMenu = (fromIndex, toIndex) => {
    if (fromIndex === toIndex || fromIndex < 0 || toIndex < 0) return;
    setSelectedMenus(prev => {
      const next = [...prev];
      const [moved] = next.splice(fromIndex, 1);
      next.splice(toIndex, 0, moved);
      return next;
    });
  };

  return (
    <div className="layout-bottom-section">
      <div className="layout-item-panel">
        <div className="layout-item-panel-title">메뉴 항목</div>
        {menuItems.map(item => (
          <div
            key={item.id}
            className={`layout-drag-item ${usedIds.has(item.id) ? 'used' : ''}`}
            draggable
            onDragStart={e => {
              setDragItem({ type: 'source', id: item.id });
              e.dataTransfer.effectAllowed = 'move';
            }}
            onDragEnd={() => {
              setDragItem(null);
              setDragOverIndex(-1);
            }}
          >
            {item.label}
          </div>
        ))}
      </div>

      <div className="layout-drop-panel menu-drop-panel">
        <div className="layout-item-panel-title">선택된 메뉴</div>
        <div
          className="menu-drop-list"
          onDragOver={e => {
            e.preventDefault();
            e.dataTransfer.dropEffect = 'move';
          }}
          onDrop={e => {
            e.preventDefault();
            if (!dragItem) return;

            if (dragItem.type === 'source') {
              appendMenu(dragItem.id);
            } else if (dragItem.type === 'selected') {
              moveMenu(dragItem.index, selectedMenus.length - 1);
            }

            setDragItem(null);
            setDragOverIndex(-1);
          }}
        >
          {selectedMenus.length === 0 && (
            <div className="menu-drop-empty">여기에 드래그해서 좌측 메뉴를 등록하세요</div>
          )}

          {selectedMenus.map((item, index) => (
            <div
              key={item.id}
              className={`menu-list-item ${dragOverIndex === index ? 'drag-over' : ''}`}
              draggable
              onDragStart={e => {
                setDragItem({ type: 'selected', id: item.id, index });
                e.dataTransfer.effectAllowed = 'move';
              }}
              onDragEnd={() => {
                setDragItem(null);
                setDragOverIndex(-1);
              }}
              onDragOver={e => {
                e.preventDefault();
                e.dataTransfer.dropEffect = 'move';
              }}
              onDragEnter={e => {
                e.preventDefault();
                setDragOverIndex(index);
              }}
              onDragLeave={() => {
                if (dragOverIndex === index) setDragOverIndex(-1);
              }}
              onDrop={e => {
                e.preventDefault();
                if (!dragItem) return;

                if (dragItem.type === 'source') {
                  const label = getManagerMenuLabelByStoredValue(dragItem.id, menuItems);
                  if (!label) return;
                  setSelectedMenus(prev => {
                    const filtered = prev.filter(menu => menu.id !== dragItem.id);
                    filtered.splice(index, 0, { id: dragItem.id, label });
                    return filtered;
                  });
                } else if (dragItem.type === 'selected') {
                  moveMenu(dragItem.index, index);
                }

                setDragItem(null);
                setDragOverIndex(-1);
              }}
            >
              <span className="menu-list-order">{index + 1}</span>
              <span className="menu-list-label">{item.label}</span>
              <button
                type="button"
                className="layout-remove-btn"
                onClick={() => {
                  setSelectedMenus(prev => prev.filter(menu => menu.id !== item.id));
                }}
              >
                x
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MenuListSelector;
